<template>
  <div class="home-container">
    <van-search
      v-model="value"
      show-action
      :label="'اسم الفيلم'"
      :placeholder="'ابحث عن فيلمك المفضل'"
      @search="onSearch"
      class="arabic-search"
    >
      <template #action>
        <div v-if="userInfo?.userId" class="username" @click="goToMe">
          {{ userInfo.username }}
        </div>
        <div v-else @click="goToLogin">التسجيل / تسجيل الدخول</div>
      </template>
    </van-search>
    <van-swipe
      :autoplay="3000"
      indicator-color="white"
      :show-indicators="false"
      :loop="false"
    >
      <van-swipe-item v-for="banner in banners" :key="banner.id">
        <img :src="banner.img" alt="" class="banner-image" />
      </van-swipe-item>
    </van-swipe>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=" لا يوجد المزيد"
      @load="loadMoreMovies"
    >
      <div class="movie-grid">
        <div
          v-for="movie in filteredMovies"
          :key="movie.id"
          class="movie-item"
          @click="goToPlayerH(movie.id)"
        >
          <div class="movie-card">
            <!-- <div class="chapter-num">
              جميع الحلقات({{ movie.chapterNums }} حلقة)
            </div> -->
            <img :src="movie.cover" alt="" class="movie-cover" />
            <div class="play-button">
              <van-icon name="play-circle-o" size="24" />
            </div>
          </div>
          <div class="movie-title">{{ movie.title }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { Search, List, Swipe, SwipeItem } from "vant";
// import { banners, search } from "@/api/api";
import { banners, loadMoreMovies, search } from "@/api/api";
import { getToken, getUserInfo } from "@/utils";

export default {
  name: "HomePage",
  components: {
    "van-search": Search,
    "van-list": List,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
  },
  data() {
    return {
      value: "",
      movies: [],
      filteredMovies: [],
      pageNo: 1,
      pageSize: 12,
      loading: false,
      finished: false,
      banners: [],
    };
  },
  computed: {
    userInfo() {
      return getUserInfo();
    },
  },
  mounted() {
    this.getBanner();
    this.filteredMovies = this.movies; // 初始化时显示所有电影
  },
  methods: {
    goToMe() {
      this.$router.push({ name: "Me" });
    },
    async getBanner() {
      try {
        const response = await banners();
        this.banners = response.data || [];
      } catch (error) {
        console.error("获取轮播图失败:", error);
      }
    },
    async onSearch() {
      try {
        const { data: newMovies, totalCount } = await search(this.value, 1, 12);
        this.filteredMovies = [];
        if (totalCount == this.filteredMovies.length) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.filteredMovies = [...this.filteredMovies, ...newMovies];
        this.pageNo++;
      } catch (error) {
        console.error("加载更多电影时出错:", error);
        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    async loadMoreMovies() {
      if (this.finished) return;
      this.loading = true;
      console.log(this.pageNo);
      console.log(this.pageSize);
      try {
        const { data: newMovies, totalCount } = await loadMoreMovies(
          this.pageNo,
          this.pageSize || 12
        );

        if (totalCount == this.filteredMovies.length) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.filteredMovies = [...this.filteredMovies, ...newMovies];
        this.pageNo++;
      } catch (error) {
        console.error("加载更多电影时出错:", error);
        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    goToPlayer(movieId) {
      this.$router.push({ name: "Player", query: { id: movieId } });
    },
    goToPlayerH(movieId) {
      if (!getToken() || getToken() == "undefined") {
        this.$router.push({ path: "/login" });
        return;
      }
      this.$router.push({ name: "PlayerH", query: { id: movieId } });
    },
    goToLogin() {
      this.$router.push({ path: "/login" }); // 使用 Vue Router 进行导航
    },
  },
  watch: {
    value(newVal) {
      console.log(newVal);
      if (newVal == "") {
        this.filteredMovies = this.movies;
        this.currentPage = 1;
        this.pageNo = 1;
        this.pageSize = 12;
        this.loading = false;
        this.finished = false;
        this.loadMoreMovies();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .van-swipe {
  margin: 10px 10px !important;
}
.home-container {
  padding: 10px;
  background-color: var(--background-color);
  gap: 10px;
  max-width: 100%;
  overflow-x: hidden;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: var(--primary-color);
  color: white;
  text-align: center;
  padding: 10px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.movie-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.movie-card {
  position: relative;
  width: 100%;
  padding-bottom: 150%; /* 控制高宽比为 2:3 */
  overflow: hidden;
  border-radius: 8px;
}

.movie-title {
  font-size: 14px;
  text-align: center;
  padding: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-color);
  box-sizing: border-box;
}

.option-button {
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
}

.option-button:hover {
  background-color: var(--hover-color);
}

.chapter-num {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px;
  border-radius: 3px;
  font-size: 12px;
  z-index: 100;
}

.van-grid-item {
  position: relative;
  width: 100%;
  margin-bottom: 8px;
}

.van-grid {
  padding: 10px 0;
  --van-grid-item-content-padding: 0;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 6px 12px;
  border-radius: 5px;
  cursor: pointer;
  z-index: 10;
}

.username {
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  max-width: 100px; /* 设置最大宽度，根据需要调整 */
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.van-swipe {
  margin: 10px 0;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .van-grid-item__content {
  padding: 8px !important;
}

.arabic-search {
  direction: rtl;
}

::v-deep .arabic-search .van-search__content {
  background-color: #f7f8fa;
  border-radius: 4px;
}

::v-deep .arabic-search .van-cell__title {
  text-align: right;
}

::v-deep .arabic-search .van-field__control {
  text-align: right;
}

::v-deep .arabic-search .van-search__action {
  padding: 0 12px;
}

.movie-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.movie-item {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
</style>